import { useState } from "react";
import { Dropdown, Modal } from "react-bootstrap";
import Spinner from "../Components/Spinner";
import ErrorMessage from "../Components/ErrorMessage";
import MandatorySign from "../Components/MandatorySign";
import { MdOutlineCheckCircle, MdOutlineCircle } from "react-icons/md";
import { BiPlus } from "react-icons/bi";
import { CiCircleAlert } from "react-icons/ci";
import NewOrganizationModal from "../Organizations/NewOrganizationModal";
import { useLanguage } from "../Translations/LenguageContext";

const GEN_BACKEND_LINK = process.env.REACT_APP_GEN_BACKEND_LINK;

const NewFolderModal = ({ account_id, userData, show, handleClose, fetchRecords, path, orgData, fetchOrgData }) => {
    const {t} = useLanguage()
    const [loadingSave, setLoadingSave] = useState(false);
    const [errorMessage, setErrorMessage] = useState({ message: "", display: false });
    const [openOrgModal, setOpenOrgModal] = useState(false)

    const [formData, setFormData] = useState({
        name: "",
        organization_ids: ["personal"]
    });

    const handleChange = (e) => {
        setFormData(prev => ({
            ...prev,
            [e.target.name]: e.target.value
        }));
    };

    const handleOrgSelect = (orgId) => {
        setFormData(prev => {
            if (orgId === "personal") {
                return {
                    ...prev,
                    organization_ids: ["personal"] 
                };
            }

            let updatedIds = prev.organization_ids.filter(id => id !== "personal");

            const alreadySelected = updatedIds.includes(orgId);

            return {
                ...prev,
                organization_ids: alreadySelected
                    ? updatedIds.filter(id => id !== orgId)
                    : [...updatedIds, orgId]
            };
        });
    };

    const handleSave = async () => {
        if (!formData.name.trim()) {
            setErrorMessage({ message: t.storage.folder_name_required, display: true });
            return;
        }

        if (formData.organization_ids.length == 0) {
            setErrorMessage({ message: t.storage.org_required, display: true });
            return;
        }

        setLoadingSave(true);
        setErrorMessage({ message: "", display: false });

        try {
            const response = await fetch(`${GEN_BACKEND_LINK}/create_folder`, {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",
                },
                body: JSON.stringify({
                    account_id: account_id,
                    name: formData.name,
                    organization_ids: formData.organization_ids,
                    path: path
                }),
            });

            const data = await response.json();

            if (!response.ok) {
                if (data.error == "folder_already_exists") {
                    setErrorMessage({ message: `${t.storage.folder_alredy_present}`, display: true });
                    return;
                }
                throw new Error(data.error || "Something went wrong");
            }


            if (data.message == "OK") {
                if (fetchRecords) {
                    await fetchRecords();
                }
                closeModal();
            }

        } catch (error) {
            setErrorMessage({
                message: error.message || "Server error",
                display: true
            });
        } finally {
            setLoadingSave(false);
        }
    };

    const closeModal = () => {
        handleClose();
        setFormData({
            name: "",
            organization_ids: ["personal"]
        });
        setErrorMessage({ message: "", display: false });
        setLoadingSave(false);
    };

    return (
        <Modal show={show} onHide={closeModal}>
            <div className="modal_header">
                <p className="modal_header_title">{t.storage.new_folder}</p>
            </div>

            <div className="modal_main_cont">
                <div className="modal_profile_input_cont">
                    <div className="label_input">
                        <label className="input_label">{t.storage.folder_name} <MandatorySign message={t.mandatory_field} /></label>
                        <input
                            type="text"
                            name="name"
                            maxLength={100}
                            value={formData.name}
                            onChange={handleChange}
                            placeholder="EX - Documents"
                            className="register_form_first fade-in"
                            autoComplete="off"
                        />
                    </div>
                </div>
                <div className="label_input">
                    <label className="input_label">{t.storage.share_with_org} <MandatorySign message={t.mandatory_field} /></label>
                    <Dropdown autoClose={"outside"}>
                        <Dropdown.Toggle
                            as="div"
                            className="register_form_first fade-in"
                        >
                            {
                                formData.organization_ids.length > 0
                                    ? `${formData.organization_ids.length} ${t.selected}`
                                    : t.select
                            }
                        </Dropdown.Toggle>
                        <Dropdown.Menu className="custom_dropdown_menu">
                            <div className="dropdown_container fade-in">
                                <button
                                    key={"personal"}
                                    onClick={() => handleOrgSelect("personal")}
                                    className="settings_link"
                                >
                                    <i >
                                        {formData.organization_ids.includes("personal")
                                            ? <MdOutlineCheckCircle />
                                            : <MdOutlineCircle />}
                                    </i>
                                    Personal
                                </button>
                                {orgData && orgData.map((org) => (
                                    <button
                                        key={org.id}
                                        onClick={() => handleOrgSelect(org.id)}
                                        className="settings_link"
                                    >
                                        <i >
                                            {formData.organization_ids.includes(org.id)
                                                ? <MdOutlineCheckCircle />
                                                : <MdOutlineCircle />}
                                        </i>
                                        {org.name}
                                    </button>
                                ))}
                                <button
                                    onClick={() => setOpenOrgModal(true)}
                                    className="settings_link"
                                >
                                    <i><BiPlus /></i> {t.create_new}
                                </button>
                            </div>
                        </Dropdown.Menu>

                    </Dropdown>
                    {
                        !formData.organization_ids.includes("personal") &&
                        formData.organization_ids.length > 0 && (
                            <p className="role_warning_text">
                                <i><CiCircleAlert /></i>{" "}
                                {t.storage.share_warning}
                            </p>
                        )
                    }
                </div>
            </div>


            <div className="modal_footer">
                <div className="modal_footer_err_cont">
                    <ErrorMessage err={errorMessage} />
                </div>

                <div className="modal_footer_btn_cont">
                    <button
                        className="modale_save_btn"
                        onClick={handleSave}
                        disabled={loadingSave}
                    >
                        {loadingSave ? <Spinner loading={true} /> : t.save}
                    </button>

                    <button
                        className="modale_close_btn"
                        onClick={closeModal}
                        disabled={loadingSave}
                    >
                        {t.close}
                    </button>
                </div>
            </div>

             <NewOrganizationModal
                account_id={account_id}
                show={openOrgModal}
                handleClose={() => setOpenOrgModal(false)}
                fetchRecords={fetchOrgData}
                userData={userData}
            />
        </Modal>
    );
};

export default NewFolderModal;